module.exports = __webpack_public_path__ + "e29a455afbac302beb32731982191c16.svg";